import './pre-init';
import './bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import API from './API';
import moment from 'moment';
import 'moment/locale/es';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';

// Importaciones necesarias para el modo "solo chat"
import { ChatProvider } from './Chat/ChatContext';
import { AsistenteVirtual } from './Chat/AsistenteVirtual';
import './Chat/AsistenteVirtual.css';
import { Global } from './App';

moment.locale('es');

const portalRoot = document.getElementById('Portal-Clientes');
const chatRoot = document.getElementById('Chat-Clientes');

// --- Bloque 1: Lógica para el portal de clientes (Full o Compact) ---
if (portalRoot) {
  portalRoot.classList.add("asyntec-portal-clientes");
  API.UrlBase = portalRoot.getAttribute("UrlApi");

  const modo = (portalRoot.getAttribute("modo") || portalRoot.getAttribute("data-modo") || "").toLowerCase();
  const vista = (portalRoot.getAttribute("vista") || portalRoot.getAttribute("data-vista") || "login").toLowerCase();
  const urlDestino = portalRoot.getAttribute("url-destino") || portalRoot.getAttribute("data-url-destino") || portalRoot.getAttribute("urldestino") || "";

  if (modo === "compact" || modo === "compacto") {
    portalRoot.classList.add("portal-compacto");
  }

  if (!portalRoot.hasChildNodes() || portalRoot.innerHTML.trim() === '') {
    portalRoot.innerHTML = '<div style="display:flex;flex-direction:column;justify-content:center;align-items:center;min-height:220px;width:100%;color:#007bff;font-family:sans-serif;"><div style="border:3px solid #e9ecef;border-top:3px solid #007bff;border-radius:50%;width:36px;height:36px;animation:asyntecSpin .8s linear infinite;margin-bottom:12px;"></div><div style="color:#6c757d;font-size:13px;font-weight:500;">Cargando...</div></div><style>@keyframes asyntecSpin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>';
  }

  const keyParam = portalRoot.getAttribute("Key");
  const urlParametros = keyParam ? `Consulta/Parametros?key=${encodeURIComponent(keyParam)}` : "Consulta/Parametros";

  API.Call(urlParametros)
    .then(async response => {
      await API.RevisarCookie();

      var ParametrosPortalClientes = {
        UrlApi: API.UrlBase,
        Key: keyParam,
        Modo: modo,
        Vista: vista,
        UrlDestino: urlDestino,
        ...(response)
      };

      ReactDOM.render(
        <BrowserRouter basename={window.location.pathname + "#"}>
          <App portal={ParametrosPortalClientes} />
        </BrowserRouter>,
        portalRoot);
    })
    .catch(err => {
      console.error("Error al inicializar Portal-Clientes:", err);
    });
}

// --- Bloque 2: Lógica CORREGIDA y ALINEADA para el chatbot independiente ---
if (chatRoot) {
  const apiUrl = chatRoot.getAttribute('UrlApi');
  const key = chatRoot.getAttribute('Key');

  API.UrlBase = apiUrl;

  // Se utiliza API.Call replicando la lógica del portal.
  API.Call(`Consulta/Parametros`)
    .then(async parametros => {
      await API.RevisarCookie();

      const config = {
        ...parametros,
        UrlApi: apiUrl,
        Key: key,
      };

      Object.assign(Global, config);

      chatRoot.classList.add("asyntec-portal-clientes");
      ReactDOM.render(
        <ChatProvider>
          <AsistenteVirtual />
        </ChatProvider>,
        chatRoot
      );
    })
    .catch(err => console.error("Error al cargar la configuración del chat:", err));

}